module.exports = __webpack_public_path__ + "static/media/healthy.49e8bde3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/card-images/healthy.png
// module id = 140
// module chunks = 0